<template>
  <el-container class="app-wrapper">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <div class="logo" @click="_toIndex">{{systemInfo.systemSimpleTitle}}</div>
        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#0f2347"
          text-color="#cbd5e1" active-text-color="#ffffff">
          <el-menu-item :index="item.caId" v-for="(item, index) in catalogs" :key="index"
            @click="_changeMenuCatalog(item, true)"><i class="fa header-menu-icon" :class="resolveMenuIcon(item)" aria-hidden="true"></i>{{ item.name }}</el-menu-item>
        </el-menu>
      </div>
      <div class="header-right">
        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
          <span class="user-info">
            {{ curCommunityName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{systemInfo.version}}</span>

      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 width="64px"-->
      <el-aside class="app-aside" width="80">
        <div class="vc-menu flex justify-start" id="menu-nav">
          <div class="vc-menu-main">
            <ul>
              <template v-for="(menu, index) in menuTree">
                <li :key="index" v-if="menu.childs && menu.childs.length > 0" :class="{ active: menu.active }"
                  class="primary-menu-item" @click="switchMenu(menu)">
                  <i class="fa" :class="resolveMenuIcon(menu)" aria-hidden="true"></i>
                  <el-tooltip :content="resolvePrimaryMenuName(menu)" placement="right" :open-delay="400"
                    :disabled="!isMenuNameLong(resolvePrimaryMenuName(menu), 4)" popper-class="menu-name-tooltip">
                    <span class="primary-menu-label">{{ resolvePrimaryMenuName(menu) }}</span>
                  </el-tooltip>
                </li>
              </template>
            </ul>
          </div>
          <div class="vc-menu-sub" v-if="subMenus && subMenus.length > 0">
            <ul>
              <li class="title">{{ curMenuName }}</li>
              <template v-for="(subMenu, index) in subMenus">
                <li :key="index" v-if="subMenu.isShow == 'Y'" class="third-menu-item" :class="{ active: subMenu.active }"
                  v-on:click="_gotoPage(subMenu.href, subMenu.name)">
                  <i class="fa fa-angle-right third-menu-item-icon" aria-hidden="true"></i>
                  <el-tooltip :content="subMenu.name" placement="right" :open-delay="400"
                    :disabled="!isMenuNameLong(subMenu.name, 5)" popper-class="menu-name-tooltip">
                    <span class="third-menu-item-text">{{ subMenu.name }}</span>
                  </el-tooltip>
                </li>
              </template>
              <li class="sub-footer" @click="_closeSubMenu()"><i class="fa fa-dedent"></i></li>
            </ul>
          </div>
        </div>
      </el-aside>

      <!-- 主要内容区 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>
    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import {listSystemInfo} from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import {initSystem} from '@/api/util/vcApi'
import config from '@/conf/config'
import { isLocalPreviewSession } from '@/utils/localUiPreview'
import { resolveMenuIcon } from '@/utils/menuIcon'
import { isMenuNameLong, resolvePrimaryMenuName } from '@/utils/menuName'


export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      menuTree: [],
      subMenus: [],
      menuWidth: 80,
      menuId: '',
      curMenuName: '',
      activeMenu: '',
      activeSubMenu: 'communityList',
      searchText: '',
      username: '',
      curCommunityName: '',
      communitys: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      }
    }
  },
  created() {
    let _user = JSON.parse(localStorage.getItem('user') || '{}');
    this.username = _user.name || '管理员'
    this.systemInfo.version = config.version
    if (isLocalPreviewSession()) {
      this.setupLocalPreview()
      return
    }
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    initSystem()
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  methods: {
    resolveMenuIcon,
    resolvePrimaryMenuName,
    isMenuNameLong,
    setupLocalPreview() {
      this.systemInfo.systemSimpleTitle = '智慧社区'
      this.systemInfo.companyName = '智慧社区'
      this.systemInfo.version = 'UI 预览'
      this.curCommunityName = '幸福里小区'
      this.storeInfo.storeTypeCd = '800900000003'
      this.communitys = [{ name: '幸福里小区' }, { name: '阳光花园' }]
    },
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
      this.systemInfo.companyName = data[0].companyName
      this.systemInfo.logoUrl = data[0].logoUrl
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys
      this.curCommunityName = getCommunityName()

    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
      } catch (error) {
        console.error('登录失败：', error)
      } finally {
        this.loading = false
      }

    },
    async loadCatalogs() {
      this.loading = true
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) {
          return;
        }
        this.catalogs = res.data;
        if (this.catalogs && this.catalogs.length > 0) {
          this._changeMenuCatalog(this.catalogs[0])
        }
      } catch (error) {
        console.error('登录失败：', error)

      } finally {
        this.loading = false
      }
    },
    _changeMenuCatalog(_catalog, _isJump) {
      this.activeMenu = _catalog.caId;
      if (this._showModelDiv(_catalog)) {
        return;
      }
      if (_catalog.caId === '1') {
        this.$router.push('/#/pages/mall/product');
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/');
        return;
      }
      if (_catalog.url == 'MALL') {
        //获取用户名
        jumpToMall('/');
        return;
      }
      console.log(_catalog)
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url, _catalog.name)
        //return;
      }
      this.loadMenuTree(_catalog)
    },

    handleCommand(command) {
      if (command === 'logout') {
        // 处理退出登录

        localStorage.removeItem('token')
        localStorage.clear();
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        // 切换语言
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
      setCurrentCommunity(community);
      this.curCommunityName = getCommunityName()
      window.location.href="/"
    },
    handleMenuSelect(index) {
      // 处理菜单选择
      this.$router.push({ name: index })
    },
    loadMenuTree(_catalog) {
      getMenuTree(_catalog).then(res => {
        let _menus = res.data;
        _menus.sort(function (a, b) {
          return a.seq - b.seq
        });
        this.menuTree = _menus;
      })
    },
    switchMenu(_menu) {
      //设置菜单ID
      this.menuId = _menu.id;
      this.menuTree = this.refreshMenuActive(this.menuTree, _menu.id);
      this.subMenus = _menu.childs;
      console.log(this.subMenus)
      this.curMenuName = this.resolvePrimaryMenuName(_menu);

      if (!_menu.childs || _menu.childs.length < 1) {
        return;
      }
      //选中第一个
      this._gotoPage(_menu.childs[0].href, _menu.childs[0].name);
      //vc._fix_height()
    },
    refreshMenuActive(jsonArray, _id) {
      for (let menuIndex = 0; menuIndex < jsonArray.length; menuIndex++) {
        if (jsonArray[menuIndex].childs) {
          let _childs = jsonArray[menuIndex].childs;
          _childs.sort(function (_child, _newChild) {
            return _child.seq - _newChild.seq
          });
          jsonArray[menuIndex].childs = _childs;
        }

        if (_id === jsonArray[menuIndex].id) {
          //如果当前本身是打开状态，说明 需要关闭
          jsonArray[menuIndex].active = true;
          continue;
        }
        jsonArray[menuIndex].active = false;
      }
      return jsonArray;
    },
    _setSelectedMenusChild(_href) {
      for (var menuIndex = 0; menuIndex < this.menuTree.length; menuIndex++) {
        if (this.menuTree[menuIndex].childs) {
          var _childs = this.menuTree[menuIndex].childs;
          for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
            if (_href == _childs[childIndex].href) {
              this.menuTree[menuIndex].childs[childIndex].active = true;
            } else {
              this.menuTree[menuIndex].childs[childIndex].active = false;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    _gotoPage(_href, _tabName) {
      console.log(_href, _tabName)
      // 子菜单默认选中
      this._setSelectedMenusChild(_href);
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }

      this.$router.push(_href).catch(err => {
        // 忽略重复导航错误
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    _showModelDiv: function (_catalog) {
      console.log(_catalog)
      if (_catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length);
        this.$refs[_modelName].open()
        return true;
      }
      return false;
    },
    _toIndex(){
      location.href = '/'
    },
    _closeSubMenu(){
      this.subMenus = []
      this.curMenuName = ''
    }

  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  position: relative;
  z-index: 10;
  background-color: var(--hc-navigation);
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 12px rgba(15, 35, 71, 0.16);
}

.header-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.logo {
  box-sizing: border-box;
  width: 100px;
  flex: 0 0 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
  white-space: nowrap;
  color: #fff;
  cursor: pointer;
}

.header-menu {
  border: none;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 24px;
  font-size: 13px;
}

.margin-left {
  margin-left: 15px;
  color: #fff;
}

.user-info {
  color: #fff;
  cursor: pointer;
}

.app-aside {
  width: auto;
}

.menu-wrapper {
  height: 100%;
}

.el-menu-vertical {
  border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.app-main {
  background-color: var(--hc-page-bg);
  height: calc(100vh - 60px);
  padding: 0px;
}

:deep(.el-menu--horizontal) {
  border-bottom: none;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-weight: 500;
}

:deep(.header-menu > .el-menu-item:hover) {
  background-color: var(--hc-navigation-hover) !important;
}

:deep(.header-menu > .el-menu-item.is-active) {
  background-color: rgba(37, 99, 235, 0.22) !important;
  border-bottom-color: var(--hc-primary) !important;
}

.header-menu-icon {
  margin-right: 8px;
  color: inherit;
  font-size: 15px;
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
}

:deep(.el-menu--collapse) {
  width: 64px;
}

:deep(.el-menu--collapse .el-submenu__title) {
  padding: 0 !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-submenu__title i) {
  margin: 0;
  font-size: 20px;
}

:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: #1e2132 !important;
}

:deep(.el-menu--popup .el-menu-item) {
  background-color: #1e2132;
  color: #fff;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #2a2f45;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  color: #409EFF;
}

.vc-menu {
  border-right: 1px solid var(--hc-border);

  .vc-menu-main {
    background-color: var(--hc-navigation);
    color: #a8b4c7;
    text-align: center;
    width: 80px;
    font-size: 14px;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;

    .active {
      background-color: var(--hc-primary);
      color: #FFFFFF;
    }
  }

  .vc-menu-main::-webkit-scrollbar {
    display: none;
  }

  ul {
    padding-inline-start: 0px;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }
}

.moreCommunity {
  font-weight: 600;
  color: #212529;
  font-size: 12px;
}

.vc-menu-main ul li {
  height: 45px;
  cursor: pointer;
  list-style-type: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.vc-menu-main ul li.primary-menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  line-height: 1;
}

.vc-menu-main ul li i {
  font-size: 18px;
  width: 24px;
  text-align: center;
  transition: color 0.2s ease, transform 0.2s ease;
}

.vc-menu-main ul li span {
  font-size: 14px;
}

.vc-menu-main ul li .primary-menu-label {
  display: block;
  box-sizing: border-box;
  width: 72px;
  overflow: hidden;
  color: inherit;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.vc-menu-main ul li:hover {
  background-color: var(--hc-navigation-hover);
  color: #FFFFFF;
}

.vc-menu-main ul li:hover i,
.vc-menu-main ul li.active i {
  transform: translateY(-1px);
}

.vc-menu-main ul li.title {
  color: #FFFFFF;
  height: 60px;
  font-size: 24px;
  line-height: 60px;
}

.vc-menu-main ul li.title a {
  text-decoration: none;
  cursor: pointer;
  color: #FFFFFF;
}

.vc-menu-sub {
  background-color: #FFFFFF;
  color: var(--hc-text-regular);
  text-align: start;
  width: 110px;
  font-size: 14px;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: scroll;
  border-right: 1px solid var(--hc-border);
  box-shadow: 4px 0 14px rgba(15, 35, 71, 0.04);
  scrollbar-width: none;
}

.vc-menu-sub::-webkit-scrollbar {
  display: none;
}

.vc-menu-sub .active {
  position: relative;
  background-color: #eff6ff;
  color: var(--hc-primary);
  font-weight: 600;
  box-shadow: inset 0 0 0 1px rgba(191, 219, 254, 0.52);
}

.vc-menu-sub .active::before {
  position: absolute;
  top: 9px;
  left: 0;
  width: 3px;
  height: 22px;
  border-radius: 0 3px 3px 0;
  background: var(--hc-primary);
  content: '';
}



.vc-menu-sub ul li {
  box-sizing: border-box;
  position: relative;
  height: 40px;
  line-height: 40px;
  padding: 0 8px 0 12px;
  width: calc(100% - 12px);
  margin: 2px 6px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 6px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.third-menu-item {
  display: flex;
  align-items: center;
}

.third-menu-item-icon {
  flex: 0 0 12px;
  width: 12px;
  margin-right: 4px;
  color: #cbd5e1;
  font-size: 12px;
  transition: color 0.2s ease, transform 0.2s ease;
}

.third-menu-item-text {
  display: block;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.third-menu-item:hover .third-menu-item-icon,
.third-menu-item.active .third-menu-item-icon {
  color: var(--hc-primary);
  transform: translateX(2px);
}

.vc-menu-sub ul li.title {
  color: var(--hc-text-primary);
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0 0 8px;
  border-radius: 0;
  border-bottom: 1px solid var(--hc-border);
  background: #f8fafc;
  letter-spacing: 0.2px;
}

.vc-menu-sub ul li.third-menu-item:hover {
  background-color: #eff6ff;
  color: var(--hc-primary);
}

.vc-menu-sub ul li.sub-footer {
  background-color: #f8fafc;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100px;
  margin: 0;
  border-radius: 0;
  color: var(--hc-text-secondary);
  border-top: 1px solid var(--hc-border);
}

.vc-menu-sub ul li.sub-footer:hover {
  color: var(--hc-primary);
  background-color: #eff6ff;
}
</style>
